module.exports = __webpack_public_path__ + "static/media/food.8b440627.jpg";